module.exports = __webpack_public_path__ + "static/media/symbol-liveplay.f47c1841.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-liveplay.svg
// module id = ./src/assets/images/symbol-liveplay.svg
// module chunks = 0